import _ from 'lodash';

export default {
  updateProfile(state, payload) {
    _.forEach(payload, (value, key) => {
      if (key in state.profile) {
        state.profile[`${key}`] = value;
      }
    });
  },
  setProfile(state, payload) {
    state.profile = payload;
  },
};
